'use client'
import React, { useState } from 'react'
import { Modal } from 'antd'
import styles from './style.module.scss'
import LanguageAndCurrencyContent from './LanguageAndCurrencyContent'

const Language = () => {
  const [isModalVisible, setIsModalVisible] = useState(false)

  const showModal = () => {
    setIsModalVisible(true)
  }

  const handleOk = () => {
    setIsModalVisible(false)
  }

  const handleCancel = () => {
    setIsModalVisible(false)
  }

  return (
    <div className={styles.container}>
      <i className="iconfont iconshezhi-24 f20" style={{ fontSize: '20px !important' }} onClick={showModal}></i>
      <Modal open={isModalVisible} onOk={handleOk} closeIcon={null} centered footer={null} width={680}>
        <LanguageAndCurrencyContent onClose={handleCancel} />
      </Modal>
    </div>
  )
}

export default Language
